import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import MaterialAndColor from '@/shared/product/customizer/ui/overlays/MaterialAndColor.vue';
import ProductFamily from '@/shared/product/customizer/ui/overlays/ProductFamily.vue';
import Comfort from '@/shared/product/customizer/ui/overlays/Comfort.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerOverlays',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MaterialAndColor),
    _createVNode(ProductFamily),
    _createVNode(Comfort)
  ], 64))
}
}

})